// extracted by mini-css-extract-plugin
export default {"topbtn":"scroll_topbtn__7-LNW","icon":"scroll_icon__wduN-","gototop":"scroll_gototop__joqia"};